import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 9a1 1 0 1 0 0-2h-3.586l4.293-4.293a1 1 0 0 0-1.414-1.414L17 5.586V2a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1zM9 2a1 1 0 0 0-2 0v3.586L2.707 1.293a1 1 0 0 0-1.414 1.414L5.586 7H2a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1zM2 15a1 1 0 1 0 0 2h3.586l-4.293 4.293a1 1 0 1 0 1.414 1.414L7 18.414V22a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1zM15 22a1 1 0 1 0 2 0v-3.586l4.293 4.293a1 1 0 0 0 1.414-1.414L18.414 17H22a1 1 0 1 0 0-2h-6a1 1 0 0 0-1 1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }